import { apiInstance } from '@core/api/instance';
import { getAPIURL } from '@common/api/helpers';
import { DictionariesEndpoint, Dictionary, IProjectAPI, ProjectRequest } from '@common/types';

export const ProjectAPI: IProjectAPI = {
  create: (params: ProjectRequest) =>
    apiInstance().post(getAPIURL(Dictionary.Project, DictionariesEndpoint.Create), { data: { values: [params] } }),
  getProjects: ({ from, till }) => apiInstance().post(getAPIURL(Dictionary.Planning, DictionariesEndpoint.GetProjects), { from, till })
};
